import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { creditCardValidation } from '../../functions/credit-card-validation';
import { IValidationHandler, TValidatorError } from '../../model';
import { trimComplete } from '@partners/utils';

export function creditCardValidator(args: IValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const isValid = creditCardValidation(trimComplete(value?.toString()));

    if (!isValid) {
      const vldResponse: TValidatorError = { creditCard: value };
      return vldResponse;
    }

    return null;
  };
}
